module.exports = __webpack_public_path__ + "img/participant-picture@dt-1.5a89aa5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/participant-picture@dt-1.svg
// module id = 20fU
// module chunks = 0